<template>
  <div class="sign-form">
    <!-- <el-form ref="NameLogin" :model="ruleForm" :rules="rules" class="demo-ruleForm"> -->
    <el-form :rules="rules" :model="ruleForm" ref="signUpForm" class="content">
      <el-form-item prop="UserName">
        <!-- placeholder="请输入账号" -->
        <el-input v-model="ruleForm.UserName" @input=" ruleForm.UserName = ruleForm.UserName.replaceAll(' ', '') "
          @blur="ruleForm.UserName = ruleForm.UserName.replaceAll(' ', '')" placeholder="請輸入5-16位數字與字母組合"
          @focus="clearValid('UserName')"/>
      </el-form-item>
      <el-form-item prop="Password">
        <!-- placeholder="请输入密码" -->
        <el-input type="password" show-password v-model="ruleForm.Password" @input="ruleForm.Password = ruleForm.Password.replaceAll(' ', '') "
          @blur="ruleForm.Password = ruleForm.Password.replaceAll(' ', '') " placeholder="請輸入6-20位密碼，必須包括數位和字母" @focus="clearValid('Password')" />
      </el-form-item>
      <el-form-item prop="Password2">
        <!-- placeholder="请再次输入密码" -->
        <el-input type="password" show-password v-model="ruleForm.Password2" placeholder="請再次輸入密碼" @focus="clearValid('Password2')" />
      </el-form-item>
      <!-- 密码强度 -->
      <PasswordStrength :password="ruleForm.Password" v-show="ruleForm.Password.length>=6"></PasswordStrength>
      <el-form-item prop="Currency" v-if="IsSingleWallet" :class="{ 'show-tips-text': IsSingleWallet && ruleForm.Currency }">
        <!-- 暂时只针对1012 -->
        <div class="el-dropdown-link wallet-dropdown" v-if="Is1012">
          <label class="coin-info" v-if="ruleForm.Currency">
            <span>
              <img class="currency-icon" :src="'/static/currency/' + ruleForm.Currency + '.png'" alt="" />
              {{ ruleForm.Currency }}
            </span>
          </label>
        </div>
        <el-dropdown v-else trigger="click" @command="choseWallet">
          <div class="el-dropdown-link wallet-dropdown" id="wallet-dropdown-link" @click="getDropdownWidth()">
            <label class="coin-info" v-if="ruleForm.Currency">
              <span>
                <img class="currency-icon" :src="'/static/currency/' + ruleForm.Currency + '.png'" alt="" />
                {{ ruleForm.Currency }}
              </span>
            </label>
            <label class="coin-info" v-else>
              選擇幣種
            </label>
            <i class="el-icon-arrow-down" v-if="!IsInviteCurrency"></i>
          </div>
          <el-dropdown-menu v-if="!IsInviteCurrency" slot="dropdown" class="wallet-drodown-menu" :style="'width:' + DropdownWidth + 'px'">
            <el-dropdown-item v-for="(item, index) in currencyListView" :key="index" :class="{ active: item.Currency == ruleForm.Currency }" :command="item.Currency">
              <div class="wallet-dropdown-item" :class="{ active: item.Currency == ruleForm.Currency }">
                <div class="wallet-item-left">
                  <img class="currency-icon" :src="'/static/currency/' + item.Currency + '.png'"  alt=""/>
                  <span>
                    {{ item.Currency }}
                  </span>
                </div>
                <div class="wallet-item-right">
                  <i class="el-icon-check" v-if="item.Currency == ruleForm.Currency"></i>
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="tips-text" v-if="IsSingleWallet && ruleForm.Currency">
          <div class="tips-label">
            <i class="el-icon-info"></i>
            <span>币种决定三方游戏和支付，且不能修改</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="RealName" v-if="config.Name == 1">
        <el-input v-model="ruleForm.RealName" placeholder="請輸入您的真實姓名" @focus="clearValid('RealName')" />
      </el-form-item>
      <el-form-item prop="PayPassword" v-if="config.PayPassword">
        <el-input v-model="ruleForm.PayPassword" type="password" autocomplete="off" placeholder="請輸入6位數字資金密碼"  @focus="clearValid('PayPassword')" />
      </el-form-item>
      <el-form-item prop="Email" v-if="config.IsEmail || config.Email" >
        <el-input type="email" v-model="ruleForm.Email" placeholder="請輸入郵箱" @focus="clearValid('Email')" />
      </el-form-item>
      <el-form-item prop="Mobile" v-if="(config.IsMobile || config.Mobile)&&USDTMobileVerification" class="country-form">
        <!-- placeholder="请输入手机号" -->
        <el-input v-model="ruleForm.Mobile" placeholder="請輸入手機號" @input="ruleForm.Mobile = ruleForm.Mobile.replace(/[^0-9.]/g, '')">
          <template slot="prepend">
            <label @click="getCountrieCode" class="country-area-label">
              <i class="iti-flag" :class="[setFlagName(ruleForm.Area)]" style=" margin-right: 4px; vertical-align: middle;"></i>
              <span>+{{ ruleForm.Area }}</span>
            </label>
          </template>
        </el-input>
        <div class="country-list-box" style="position: relative;height: 0;" v-if="AreaCodeShow">
          <CountryFlag :AreaCodeList="AreaCodeList" @getCountrieCode="getCountrieCode"></CountryFlag>
        </div>
      </el-form-item>
      <el-form-item prop="ImgCode" v-if="config.IsEmail || (config.IsMobile&&USDTMobileVerification) ">
        <div class="form-item-div">
          <div class="code-flex">
            <el-input class="code-ipt" v-model="ruleForm.ImgCode" type="text" autocomplete="off" placeholder="請輸入圖形碼" />
            <img class="codePic" :src="codeImgSrc" @click="getImgSrc()" />
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="VerCode" v-if="config.IsEmail || (config.IsMobile&&USDTMobileVerification)">
        <el-input :class="{ appendDisable: sendDisable }" v-if="verTypeActive == 'Mobile' && config.IsMobile&&USDTMobileVerification"
          v-model="ruleForm.VerCode" placeholder="請輸入手機驗證碼" autocomplete="off">
          <template #append>
            <button type="button" @click="sendCode()">
              {{ sendText }}{{ sendDisable ? "s" : "" }}
            </button>
          </template>
        </el-input>
        <el-input :class="{ appendDisable: sendDisable }" v-if="verTypeActive == 'Email' && config.IsEmail"
        v-model="ruleForm.VerCode" placeholder="請輸入郵箱驗證碼" autocomplete="off">
          <template #append>
            <button type="button" @click="sendCode()">
              {{ sendText }}{{ sendDisable ? "s" : "" }}
            </button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item v-if="siteInfo.InviteCode" v-show="showInviteCode">
        <el-input v-model="ruleForm.InviteCode" :disabled="true" />
      </el-form-item>
      <el-form-item v-else prop="InviteCode" v-show="showInviteCode"
      :class="{'show-tips-text': IsSingleWallet && hasInviteCode&&parentType=='Member'}">

        <el-input v-model="ruleForm.InviteCode" :placeholder="InvitePlaceholder" @input="enterInviteCode"
          @blur="getInviteCurrency" @focus="clearValid('InviteCode')"/>
        <div class="tips-text" v-if="IsSingleWallet &&hasInviteCode&&parentType=='Member'" >
          <div class="tips-label">
            <i class="el-icon-info"></i>
            <span>邀請碼的幣種和你的幣種須一致，否則綁定失效</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="drawer-footer" :class="{ 'mt50': IsSingleWallet }">
      <el-button type="primary" class="btn confirm-btn" @click="submitForm()" :loading="loading">
        <!-- 注册 -->
        註冊
      </el-button>
    </div>
    <!--滑块验证码弹窗 -->
    <SliderVerification
      v-if="get_ShowCaptcha"
      :visible="get_ShowCaptcha"
      @success="VerificationSuccess"
      @failed="VerificationFailed"
      @error="VerificationError"
      @close="VerificationClose"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import signMixins from "../mixins/sign-mixins"
import PasswordStrength from "@/components/PasswordStrength"
import SliderVerification from "@/components/SliderVerification.vue"
export default {
  name: 'SignForm',
  mixins: [signMixins],
  components: {
    PasswordStrength,
    SliderVerification
  },
  data () {
    return {
    }
  },
  methods:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SignForm.vue